import { render, staticRenderFns } from "./AlertsServiceView.vue?vue&type=template&id=571c7a32&scoped=true&"
import script from "./AlertsServiceView.vue?vue&type=script&lang=js&"
export * from "./AlertsServiceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571c7a32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('571c7a32')) {
      api.createRecord('571c7a32', component.options)
    } else {
      api.reload('571c7a32', component.options)
    }
    module.hot.accept("./AlertsServiceView.vue?vue&type=template&id=571c7a32&scoped=true&", function () {
      api.rerender('571c7a32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/alerts/AlertsServiceView.vue"
export default component.exports